import React, { } from "react";
import { useTranslation } from "react-i18next";
import { Button, InputFieldList, Modal, SelectFieldList } from "../..";
import { colors, css, fonts, glyphs } from "../../../Styles";
import { ButtonTypes } from "../../../Definitions";

import { LocationData } from "../../../Assets/TestData/locations";
import { ConditionData } from "../../../Assets/TestData/conditions";
import { AnimalGroupData } from "../../../Assets/TestData/animalGroups";
import { AnimalTypes } from "../../../Assets/TestData/animalData";
import { TestData as FeedCurveData } from '../../../Assets/TestData/feedCurvesData';

interface AddAnimalModal_Props {
  isModalOpen: boolean
  closeModal: () => void,
}

export default function AddAnimalModal({isModalOpen, closeModal}:AddAnimalModal_Props) {
  const {t} = useTranslation()

  const LocationOptions = LocationData.map(location => ({
    label: location.locationName
  }))
  const ConditionOptions = ConditionData.map(condition =>({
    label: condition.conditionName
  }))
  const FeedCurvesOptions = FeedCurveData.map(feedCurve =>({
    label: feedCurve.name
  }))
  const GroupOptions = AnimalGroupData.map(animalGroup => ({
    label: animalGroup.groupName
  }))
  const AnimalTypeOptions = Object.values(AnimalTypes).map(type => ({
    label: type,
  }))
    
  return (
    <Modal 
      isModalOpen={isModalOpen}
      overrides={{ 
        isPrimaryComponent: true 
      }}
      modalHeader={t("animalPages.animal.newAnimal")}
      onCloseBtn={closeModal}
    >
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "20px"}}>
        <div style={{ display: "flex", flexWrap: "wrap", alignItems: "start", justifyContent: "center", gap: "40px"}}>
          <div style={{ display: "flex", flexDirection: "column"}}>
            <p style={{ ...fonts.header, ...fonts.textShadow, ...fonts.fontSize4, color: colors.greyLightTertiary, padding: "0px 0px 5px 22px" }}>{t("required")}</p>
            <InputFieldList 
              startEnhancers={[glyphs.AnimalNumber({size: "25px"}), glyphs.ResponderNumber({size: "25px"}), glyphs.LifeNumber({size: "25px"})]}
              placeholder={[t("animalPages.animal.animalId")+"...", t("animalPages.animal.responderNo")+"...", t("animalPages.animal.lifeNo")+"..."]}
              inputTypes={["number", "number", "number"]}
              isRequired={[true, true, true]}
              listStyle="vertical"
              listGap="10px"
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column"}}>
            <p style={{ ...fonts.header, ...fonts.textShadow, ...fonts.fontSize4, color: colors.greyLightTertiary, padding: "0px 0px 5px 22px" }}>{t("optional")}</p>
            <SelectFieldList 
              startEnhancer={[glyphs.Location({size: "25px"}), glyphs.Condition({size: "25px"}), glyphs.Animal({size: "25px"}), glyphs.AnimalGroup({size: "25px"}), glyphs.AnimalType({size: "25px"})]}
              placeholder={[t("animalPages.animal.location")+"...", t("animalPages.animal.condition")+"...", t("feed.feedPlan.feedPlan")+"...", t("animalPages.animal.group")+"...", t("animalPages.animal.animalType")+"..."]}
              listStyle="vertical"
              options={[LocationOptions, ConditionOptions, FeedCurvesOptions, GroupOptions, AnimalTypeOptions]}
              listGap="10px"
            />
          </div>
        </div>
        <Button 
          content={t("buttons.createBtn")}
          buttonType={ButtonTypes.primaryButton}
          overrides={{
            baseButton: {...css.button_FitContent}
          }}
        />
      </div>
    </Modal>
  );
}